import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatButtonModule,
  MatMenuModule,
  MatTooltipModule,
  MatProgressSpinnerModule,
  MatCheckboxModule,
} from '@angular/material';
import { XpoGMapBoardModule } from '@xpo-ltl/ngx-ltl-board-gmaps';
import { XpoAgGridBoardModule } from '@xpo-ltl/ngx-ltl-board-grid';
import { XpoButtonModule, XpoCardModule } from '@xpo-ltl/ngx-ltl-core';
import { AgGridModule } from 'ag-grid-angular';
import { InboundPlanningSharedModule } from '../../shared';
import { pndFrameworkComponentsDeclarations } from '../../shared/components/frameworkComponents';
import { RouteStopsComponent } from './route-stops.component';
import { StopsNotFoundComponent } from './stops-not-found';

@NgModule({
  declarations: [RouteStopsComponent, StopsNotFoundComponent],
  exports: [RouteStopsComponent, StopsNotFoundComponent],
  entryComponents: [RouteStopsComponent],
  imports: [
    AgGridModule.withComponents(pndFrameworkComponentsDeclarations),
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    XpoButtonModule,
    XpoAgGridBoardModule,
    XpoCardModule,
    XpoGMapBoardModule,
    InboundPlanningSharedModule,
  ],
})
export class RouteStopsModule {}
